<template>
  <v-container fluid>
    <v-row class="text-center" justify="center">
      <v-col cols="12" sm="8" md="7">
        <v-card class="elevation-12" max-width="800" min-width="400">
          <v-toolbar :dark="$vuetify.theme.dark" color="primary">
            <v-col cols="8" md="10">
              <v-toolbar-title>
                {{ $t('Загрузка производственного календаря') }}
              </v-toolbar-title>
            </v-col>
            <v-col cols="2" md="1" class="text-right">
              <btn-icon-tip
                  icon="get_app"
                  :tip="$t('Скачать JSON файл производственного календаря')"
                  icon-color="secondaryiconbtn"
                  @click="getProductionCalendar" />
            </v-col>
            <v-col cols="2" md="1" class="text-right">
              <file-input
                  ref="fileInput"
                  color="secondaryiconbtn"
                  icon="add_circle_outline"
                  :accept="accept"
                  :tip="$t('Выбрать и загрузить JSON файл производственного календаря')"
                  @change="setProductionCalendar" />
            </v-col>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear :active="isLoading" color="loader" indeterminate />
            <v-alert
                class="text-center"
                outlined
                :value="success"
                type="success">
              {{ $t('Календарь загружен') }}
            </v-alert>
            <general-error v-if="!!generalError" />
            <v-date-picker
                :allowed-dates="checkDate"
                no-title
                scrollable
                :locale="controlLocale"
                :first-day-of-week="1" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import FileInput from '@/components/reused/ui/FileInput.vue'
  import BtnIconTip from '@/components/reused/ui/BtnIconTip.vue'
  import { mapActions, mapState } from 'vuex'
  import { CALENDAR } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      BtnIconTip,
      FileInput
    },
    data () {
      return {
        accept: '.txt,.json',
        isLoading: false,
        success: false
      }
    },
    computed: {
      ...mapState(CALENDAR.NAMESPACE, { dayOffDays: CALENDAR.STATE.DAY_OFF_DAYS }),
      dayOffDates () {
        const vm = this
        const years = vm.dayOffDays || []
        let list = []
        Object.keys(years).forEach(year => {
          if (years[year].length) {
            list = list.concat(years[year])
          }
        })

        return list.map(d => vm.$moment(d).format('YYYY-MM-DD'))
      }
    },
    created: function () {
      if (!this.dayOffDays) {
        this.initialize()
      }
    },
    methods: {
      ...mapActions(CALENDAR.NAMESPACE, {
        getDayOffDatesAction: CALENDAR.ACTIONS.GET_DAY_OFF_DATES,
        getProductionCalendarFileAction: CALENDAR.ACTIONS.GET_PRODUCTION_CALENDAR_FILE,
        loadProductionCalendarAction: CALENDAR.ACTIONS.LOAD_PRODUCTION_CALENDAR
      }),
      checkDate: function (val) {
        return !this.dayOffDates ||
          !this.dayOffDates.length ||
          !this.dayOffDates.includes(val)
      },
      initialize: async function () {
        try {
          this.isLoading = true
          await this.getDayOffDatesAction()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      getProductionCalendar: async function () {
        try {
          this.isLoading = true
          await this.getProductionCalendarFileAction()
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      setProductionCalendar: async function (file) {
        if (!file || file.size === 0) {
          return
        }
        const form = new FormData()
        form.append('file', file.file, file.name)
        try {
          this.isLoading = true
          this.success = false
          await this.loadProductionCalendarAction(form)
          this.isLoading = false
          this.success = true
          this.initialize()
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      }
    }
  }
</script>
